import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface ChunkErrorBoundaryProps {
  children: ReactNode;
  resetKey: string;
  homePath?: string;
}

interface ChunkErrorBoundaryState {
  error: Error | null;
}

export class ChunkErrorBoundary extends Component<ChunkErrorBoundaryProps, ChunkErrorBoundaryState> {
  state: ChunkErrorBoundaryState = { error: null };
  private container: HTMLElement | null = null;
  private focusFrame = 0;

  static getDerivedStateFromError(error: Error): ChunkErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Account Web route failed to render', error, info.componentStack);
    this.focusFrame = window.requestAnimationFrame(() => this.container?.focus({ preventScroll: true }));
  }

  componentDidUpdate(previous: ChunkErrorBoundaryProps) {
    if (previous.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  componentWillUnmount() {
    if (this.focusFrame) window.cancelAnimationFrame(this.focusFrame);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <section
        ref={(node) => { this.container = node; }}
        className="route-load-error"
        role="alert"
        aria-live="assertive"
        tabIndex={-1}
      >
        <span className="route-load-error__mark" aria-hidden="true">!</span>
        <h2>Не удалось открыть раздел</h2>
        <p>Соединение могло прерваться во время обновления платформы. Обновите страницу — введённые на сервере данные не потеряются.</p>
        <div>
          {this.props.homePath ? <button type="button" className="btn btn-secondary" onClick={() => window.location.assign(this.props.homePath!)}>К встречам</button> : null}
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Обновить страницу</button>
        </div>
      </section>
    );
  }
}
